import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';

import { history } from './store';

import WithNotifyAlert, { NotifyAlertProvider } from './containers/WithNotifyAlert';
import Redirect from './containers/Redirect'

// VIEW COMPONENTS:
import HomePage from './containers/HomePage';
import LoginPage from './containers/LoginPage';

const routes = (
  <ConnectedRouter history={history}>
      <Switch>
        <Route exact path="/" component={NotifyAlertProvider(WithNotifyAlert(HomePage))} />
        <Route exact path="/login/pin" component={LoginPage} />
        <Route exact path="/redirect/:urlRedirect" component={Redirect} />
      </Switch>
  </ConnectedRouter>
);

export default routes;
